<script setup>
import ProductFeedTable from '@frontJs/components/tables/projectManagement/sma/ProductFeedTable.vue';
import TenantReportProductFeedTable from '@frontJs/components/tables/projectManagement/sma/tenantReports/ProductFeedTable.vue';
import ProjectManagementLayout from '@frontJs/layouts/ProjectManagementLayout.vue';
import { Head } from '@inertiajs/vue3';
import PageTitle from '@js/components/titles/PageTitle.vue';

const { tenant } = defineProps({
    tenant: {
        type: Object,
        required: false,
    },
});

defineOptions({ layout: ProjectManagementLayout });
</script>

<template>
    <Head>
        <title>Flux produits - SMA - Gestion de projet - Datakepler</title>
    </Head>

    <PageTitle :tenant-name="tenant ? tenant.name : undefined">
        Gestion de projet - SMA - Flux produits
    </PageTitle>

    <ProductFeedTable v-if="tenant" :tenant="tenant" />
    <TenantReportProductFeedTable v-else />
</template>
